export const resolveBaseState = () => {
    return ['$state', 'properties', ($state, properties) => {
        return properties.find()
            .catch(error => $state.transitionTo(error));
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/resolvers/base.resolver.js